import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import formatDate from '@/services/general/formatIsoDate';
import { SENS_VENTE } from '@/configuration/devisConf';
import {
  CATEGORIE_AUTRE, CATEGORIE_DIVERS, CATEGORIE_SPONSORING, CATEGORIE_SALON,
} from '@/configuration/catalogue/produitConf';
import calculDatePremiereAffichage from '@/services/dcf/calculDates/calculDatePremiereAffichage';
import calculArrondi from '@/services/calcul/calculArrondi';
import getExonerationTva from '@/services/tiers/getExonerationTva';

function calculArrondieLignesRemise(ligne) {
  if (ligne.lignesRemise && ligne.lignesRemise.length > 0) {
    ligne.lignesRemise.forEach((ligneRemise) => {
      ligneRemise.remise = calculArrondi(ligneRemise.remise, 5);
      ligneRemise.montantARemise = calculArrondi(ligneRemise.montantARemise);
    });
  }
}

function preparationEnvoiBackLigneCmdSelProduit(ligneCommande) {
  ligneCommande.ligneReseau?.lignesCmdSelProduits?.forEach((ligne) => {
    ligne.dateDebut = formatDate(ligne.dateDebut);
    ligne.dateFin = formatDate(ligne.dateFin);
  });
}

function preparationEnvoiBackLigneCmdSelOptionProduit(ligneCommande) {
  ligneCommande.lignesCmdSelOptionProduit?.forEach((ligne) => {
    ligne.dateDebut = formatDate(ligne.dateDebut);
    ligne.dateFin = formatDate(ligne.dateFin);
  });
}

export default function preparationEnvoiBack(devisCommandeFacture) {
  const copieNouveauDevisCommande = cloneDeep(devisCommandeFacture);
  copieNouveauDevisCommande.commissions = devisCommandeFacture.commissions;
  copieNouveauDevisCommande.tauxPenalite = calculArrondi(copieNouveauDevisCommande.tauxPenalite);
  copieNouveauDevisCommande.tauxEscompte = calculArrondi(copieNouveauDevisCommande.tauxEscompte);
  if (devisCommandeFacture.sens === SENS_VENTE
    && (devisCommandeFacture.categorieVente !== CATEGORIE_DIVERS
      && devisCommandeFacture.categorieVente !== CATEGORIE_SALON
      && devisCommandeFacture.categorieVente !== CATEGORIE_SPONSORING
      && devisCommandeFacture.categorieVente !== CATEGORIE_AUTRE)) {
    copieNouveauDevisCommande.datePremierAffichage = calculDatePremiereAffichage(
      devisCommandeFacture.lignesCommande,
    );
  }
  const indexLigneIntervenantAjout = copieNouveauDevisCommande
    .intervenants.findIndex(intervenant => {
      return !intervenant.nomCommercial;
    });
  if (indexLigneIntervenantAjout !== -1) {
    copieNouveauDevisCommande.intervenants.splice(
      indexLigneIntervenantAjout,
      1,
    );
  }
  copieNouveauDevisCommande.intervenants.forEach((intervenant) => {
    intervenant.repartition = calculArrondi(intervenant.repartition);
    delete intervenant.contact;
    delete intervenant.tiers;
    intervenant.intervenantContacts.forEach(intervenantC => {
      delete intervenantC.contact;
    });
  });
  if (copieNouveauDevisCommande.dateDevisCommande) {
    copieNouveauDevisCommande.dateDevisCommande = moment(
      copieNouveauDevisCommande.dateDevisCommande,
    ).format('YYYY-MM-DD');
  }
  if (copieNouveauDevisCommande.dateValidite) {
    copieNouveauDevisCommande.dateValidite = moment(copieNouveauDevisCommande.dateValidite)
      .format('YYYY-MM-DD');
  }
  if (copieNouveauDevisCommande.dateRenouvellement) {
    copieNouveauDevisCommande.dateRenouvellement = moment(
      copieNouveauDevisCommande.dateRenouvellement,
    )
      .format('YYYY-MM-DD');
  }
  if (copieNouveauDevisCommande.datePreavis) {
    copieNouveauDevisCommande.datePreavis = moment(copieNouveauDevisCommande.datePreavis)
      .format('YYYY-MM-DD');
  }
  if (copieNouveauDevisCommande.datePremierAffichage) {
    copieNouveauDevisCommande.datePremierAffichage = moment(
      copieNouveauDevisCommande.datePremierAffichage,
    )
      .format('YYYY-MM-DD');
  }
  if (copieNouveauDevisCommande.echeanciers) {
    copieNouveauDevisCommande.echeanciers.forEach((echeancier) => {
      delete echeancier.openEcheancierLignes;
      echeancier.dateDebut = formatDate(echeancier.dateDebut);
      echeancier.dateFin = formatDate(echeancier.dateFin);
      echeancier.dateFinPremiereEcheance = formatDate(echeancier.dateFinPremiereEcheance);
      echeancier.echeancierLignes.forEach((ligne) => {
        if (ligne.fromGeneration) delete ligne.id;
        ligne.dateDebut = formatDate(ligne.dateDebut);
        ligne.dateFin = formatDate(ligne.dateFin);
        if (ligne.montant) {
          ligne.montant = calculArrondi(ligne.montant);
        }
        ligne.datePrevisionnelleFacturation = formatDate(ligne.datePrevisionnelleFacturation);
      });
    });
  }
  if (copieNouveauDevisCommande.echeancierPaiement && copieNouveauDevisCommande.montantTtc === 0) {
    copieNouveauDevisCommande.echeancierPaiement = [];
  }
  const isPayeurExonerationTva = devisCommandeFacture.sens === SENS_VENTE
    && copieNouveauDevisCommande.intervenants.some((int) => {
      return int.payeur && getExonerationTva(int);
    });
  copieNouveauDevisCommande.lignesCommande.forEach((ligne) => {
    if (isPayeurExonerationTva) ligne.tauxTva = 0;
    ligne.quantite = calculArrondi(ligne.quantite, 10);
    ligne.prixUnitaire = calculArrondi(ligne.prixUnitaire, 5);
    ligne.remise = calculArrondi(ligne.remise, 5);
    ligne.tauxTva = calculArrondi(ligne.tauxTva);
    if (ligne.quantiteDispo) ligne.quantiteDispo = calculArrondi(ligne.quantiteDispo);
    if (!ligne.prixUnitaire) {
      ligne.prixUnitaire = 0;
    }
    calculArrondieLignesRemise(ligne);
    preparationEnvoiBackLigneCmdSelProduit(ligne);
    if (ligne.lignesCommande) {
      ligne.lignesCommande.forEach((ligneEnfant) => {
        if (isPayeurExonerationTva) ligneEnfant.tauxTva = 0;
        delete ligneEnfant.dateDebut;
        delete ligneEnfant.dateFin;
        if (!ligneEnfant.prixUnitaire) ligneEnfant.prixUnitaire = 0;
        ligneEnfant.quantite = calculArrondi(ligneEnfant.quantite, 10);
        ligneEnfant.prixUnitaire = calculArrondi(ligneEnfant.prixUnitaire, 5);
        ligneEnfant.remise = calculArrondi(ligneEnfant.remise, 5);
        ligneEnfant.tauxTva = calculArrondi(ligneEnfant.tauxTva);
        calculArrondieLignesRemise(ligneEnfant);
        preparationEnvoiBackLigneCmdSelProduit(ligneEnfant);
      });
    }
    if (ligne.dateDebut) {
      ligne.dateDebut = moment(ligne.dateDebut).format('YYYY-MM-DD');
    }
    if (ligne.dateFin) {
      ligne.dateFin = moment(ligne.dateFin).format('YYYY-MM-DD');
    }
    if (ligne.dateLivraison) {
      ligne.dateLivraison = moment(ligne.dateLivraison).format('YYYY-MM-DD');
    }
    // formatage des dates venant de la gestion des BAT
    if (ligne.dateBatModification) {
      ligne.dateBatModification = formatDate(ligne.dateBatModification);
    }
    if (ligne.dateBatCreation) ligne.dateBatCreation = formatDate(ligne.dateBatCreation);
    if (ligne.dateBatDemande) ligne.dateBatDemande = formatDate(ligne.dateBatDemande);
    if (ligne.dateBatFormat) ligne.dateBatFormat = formatDate(ligne.dateBatFormat);
    if (ligne.dateBatRecu) ligne.dateBatRecu = formatDate(ligne.dateBatRecu);
    if (ligne.dateDemandeVisuel) ligne.dateDemandeVisuel = formatDate(ligne.dateDemandeVisuel);
    if (ligne.dateEnvoiBat) ligne.dateEnvoiBat = formatDate(ligne.dateEnvoiBat);
    if (ligne.dateTransmisPAO) ligne.dateTransmisPAO = formatDate(ligne.dateTransmisPAO);
    if (ligne.dateValidationVRP) ligne.dateValidationVRP = formatDate(ligne.dateValidationVRP);
    if (ligne.ligneCommandeDispositif?.nomenclature) {
      ligne.ligneCommandeDispositif.nomenclature = JSON.stringify(
        ligne.ligneCommandeDispositif.nomenclature);
    }
    preparationEnvoiBackLigneCmdSelOptionProduit(ligne);
  });
  if (copieNouveauDevisCommande.factorDateTransmission) {
    copieNouveauDevisCommande.factorDateTransmission = moment(
      copieNouveauDevisCommande.factorDateTransmission,
    ).format('YYYY-MM-DD');
  }
  if (copieNouveauDevisCommande?.etatSuivis) {
    copieNouveauDevisCommande.etatSuivis.forEach((item) => {
      if (item.date) item.date = moment(item.date).format('YYYY-MM-DD');
      if (!item.isCreate) return;
      delete item.isCreate;
      delete item.id;
    });
  }
  if (copieNouveauDevisCommande.dateTransmissionAuClub) {
    copieNouveauDevisCommande.dateTransmissionAuClub = moment(copieNouveauDevisCommande.dateTransmissionAuClub).format('YYYY-MM-DD');
  }
  if (copieNouveauDevisCommande.dateTransmissionAuClient) {
    copieNouveauDevisCommande.dateTransmissionAuClient = moment(copieNouveauDevisCommande.dateTransmissionAuClient).format('YYYY-MM-DD');
  }
  // indexation
  copieNouveauDevisCommande.dateIndexationReference = formatDate(
    copieNouveauDevisCommande.dateIndexationReference);
  copieNouveauDevisCommande.dateDerniereIndexation = formatDate(
    copieNouveauDevisCommande.dateDerniereIndexation);
  copieNouveauDevisCommande.valeurIndexationReference = calculArrondi(
    copieNouveauDevisCommande.valeurIndexationReference);
  copieNouveauDevisCommande.valeurIndexationActuel = calculArrondi(
    copieNouveauDevisCommande.valeurIndexationActuel);
  return copieNouveauDevisCommande;
}
